import type { EntityConfig } from '@/v2/framework/registry/types'
import { createTournamentsView } from './grid/view'

export default {
  id: 'tournaments',
  name: 'tournaments',
  title: 'metadata.tournaments',
  position: 3,
  create: (ctx) => createTournamentsView(ctx),
} satisfies EntityConfig
